<app-table *ngIf="data == null" [configurationTable]="configurationTable"></app-table>

<div class="modal-content event" *ngIf="data != null">
    <div class="modal-header border-0">
        <h3 class="modal-title" id="modulesModalLabel"></h3>
        <button type="button" class="btn-close" (click)="modalEvent.dismissAll()"></button>
    </div>
    <div class="modal-body py-4 px-0">
        <app-table-modal [configurationTable]="applyFilterModal()"></app-table-modal>
    </div>
</div>
